const getters = {
  progress: (state) => state.progress,
}

export { getters }
